import React, { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { Breadcrumbs, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { useParams } from 'react-router';
import { toNullableNumber } from '@/utils/html';
import { useAsyncState } from '@/utils/hooks';
import { getResidentialUnit } from '@/services/residential-units';
import { PageTitle, SimplePageTitle } from '@/components/layout/PageTitle';
import theme from './ResidentialUnitCommentThreadMobile.module.scss';
import { CommentThread } from '@ygtechnologies/bygr-frontend-chat';
import { BreadcrumbsProjectLink } from '@/components/navigation';

interface ResidentialUnitCommentThreadMobileProps {
    profileId: number;
    residentialUnitId: number;
}

const ResidentialUnitCommentThreadMobile: React.FC<ResidentialUnitCommentThreadMobileProps> = ({
    profileId,
    residentialUnitId,
}) => {
    const { id: threadId } = useParams<{ id: string | undefined }>();
    const selectedThread = toNullableNumber(threadId || '');
    const [residentialUnit] = useAsyncState(() => getResidentialUnit(residentialUnitId), [residentialUnitId], null);

    const { tab } = useParams<{ tab: string }>();
    const [threadName, setThreadName] = useState('');

    if (!residentialUnit) {
        return <LoadingIndicator />;
    }

    return (
        <div className={theme.container}>
            <SimplePageTitle title={residentialUnit.name} />

            <Breadcrumbs>
                <BreadcrumbsProjectLink to="/residential-units">
                    <Trans>All units</Trans>
                </BreadcrumbsProjectLink>

                <BreadcrumbsProjectLink to={`/residential-units/${residentialUnit.id}/${tab}`}>
                    <span>{residentialUnit.name}</span>
                </BreadcrumbsProjectLink>

                <Breadcrumbs.Item>
                    <span>{threadName}</span>
                </Breadcrumbs.Item>
            </Breadcrumbs>
            <CommentThread
                threadId={selectedThread!}
                onThreadLoad={(thread) => setThreadName(thread?.threadName ?? '')}
            />
        </div>
    );
};

export default ResidentialUnitCommentThreadMobile;